import AxiosCommonRequestInterceptor from '@/AjaxInterceptors/Request/common';

/**
 * Setting up axios interceptors
 */
axios.interceptors.request.use(AxiosCommonRequestInterceptor);



// WEBPACK FOOTER //
// ./templates/floor/assets/js/Global/bootstrap.js